import { TITLE } from './domain';

export const translations = {
    WHATSAPP_MESSAGE: `Ciao! Ho trovato il tuo profilo su ${TITLE} e vorrei incontrarti.`,
}